import styled from "styled-components";
import { Flex, Box, Text } from "rebass";
import { maxWidth, width, height, display } from "styled-system";
import SVG from "react-inlinesvg";
import Link from "next/link";
import { NAV, LEGAL, CONTACT, SOCIAL } from "./content";
import { theme } from "../../styles/theme";
import { withRouter } from "next/router";

// Extra margin on bottom for contrast accessibility with background
const Footer = withRouter(({ router }) => {
  return (
    <Box as="footer" py={[4, 4, 4, 6]} p={[3, 3, 3, 4]} mb={[0, 200]}>
      <Inner maxWidth={3} mx="auto">
        <Flex flexWrap="wrap">
          {/* Logo */}
          <Box width={[1, 1, 1, 1 / 3]}>
            <LogoWrap pr={[0, 0, 0, 4]}>
              <Link as="/" href="/index" prefetch>
                <a>
                  <Logo
                    display="block"
                    width={[200, 200, 200, 284]}
                    height={[50, 50, 50, 71]}
                    src="/static/images/logo.svg"
                  />
                </a>
              </Link>
            </LogoWrap>
          </Box>
          {/* Main navigation */}
          <Box width={[1, 1, 1, 2 / 3]} mt={[4, 4, 4, 0]}>
            <Flex
              as="nav"
              flexWrap="wrap"
              mx={[
                -theme.space[3] / 2,
                -theme.space[3] / 2,
                -theme.space[3] / 2,
                -theme.space[4] / 2
              ]}
            >
              {NAV.map((group, i) => (
                <Box
                  key={i}
                  width={[1 / 2, 1 / 4, 1 / 4]}
                  mt={i > 1 ? [4, 0] : 0}
                  px={[
                    theme.space[3] / 2,
                    theme.space[3] / 2,
                    theme.space[3] / 2,
                    theme.space[4] / 2
                  ]}
                >
                  <NavGroupTitle fontSize={2} fontFamily="boldItalic" mb={4}>
                    {group.title}
                  </NavGroupTitle>
                  {group.items.map((item, n) => (
                    <NavLink
                      key={n}
                      mt={n > 0 ? 3 : 0}
                      fontSize={1}
                      fontFamily="medium"
                      active={router.pathname === item.url}
                    >
                      {/* Handle inbound and outbound urls */}
                      {item.internal ? (
                        <Link prefetch key={n} href={item.url}>
                          <a>
                            {item.text}
                          </a>
                        </Link>
                      ) : (
                        <Text
                          as="a"
                          target="_blank"
                          href={item.url}
                        >
                          {item.text}
                        </Text>
                      )}
                    </NavLink>
                  ))}
                </Box>
              ))}
            </Flex>
          </Box>
        </Flex>
        {/* Contact email */}
        <Text
          textAlign="center"
          fontFamily="medium"
          fontSize={1}
          mt={[5, 5, 6]}
          dangerouslySetInnerHTML={{ __html: CONTACT }}
        />
        {/* Social links */}
        <Text textAlign="center" mt={4}>
          {SOCIAL.map((platform, i) => (
            <SocialIcon
              key={i}
              as="a"
              title={platform.title}
              ml={i > 0 ? 45 : 0}
              href={platform.url}
              target="_blank"
              width={platform.width}
              height={platform.height}
            >
              <SVG src={platform.icon} />
            </SocialIcon>
          ))}
        </Text>
        {/* Legal */}
        <Legal
          mt={4}
          fontFamily="medium"
          fontSize={1}
          textAlign="center"
          dangerouslySetInnerHTML={{ __html: LEGAL }}
        />
      </Inner>
    </Box>
  );
});

const LogoWrap = styled(Box)`
  a {
    display: inline-block;
  }
`;

const SocialIcon = styled(Box)`
  ${height}
  display: inline-block;
  transition: opacity 0.3s cubic-bezier(0.465, 0.183, 0.153, 0.946);

  &:hover {
    opacity: 0.7;
  }

  a,
  svg {
    display: block;
  }

  svg {
    width: 100%;
    height: 100%;
    fill: white;
  }
`;

const Legal = styled(Text)`
  opacity: 0.4;
  a {
    text-decoration: underline;
  }
`;

const NavGroupTitle = styled(Text)`
  text-transform: uppercase;
`;

const NavLink = styled(Text)`
  a {
    transition: opacity 0.3s cubic-bezier(0.465, 0.183, 0.153, 0.946);
    text-decoration: ${props => (props.active ? "underline" : "none")};
  }
  & a:hover {
    opacity: 0.7;
  }
`;

const Logo = styled(SVG)`
  ${width}
  ${height}
  ${display}

  svg {
    fill: white;
    width: 100%;
    height: 100%;
  }
`;

const Inner = styled(Box)`
  ${maxWidth}
`;

export { Footer };
